import React from 'react';
import HeroSection from '../components/HeroSection';
import '../App.css';
import { Helmet } from 'react-helmet-async';

const Services = () => {
  const services = [
    {
      title: 'Route-to-Market Strategy',
      description: 'Comprehensive market entry and expansion strategies tailored for Southern African markets.',
      icon: '📈',
      details: [
        'Market analysis and opportunity assessment',
        'Distribution network design',
        'Channel partner identification and management'
      ]
    },
    {
      title: 'Supply Chain Management',
      description: 'End-to-end supply chain solutions designed for resilience and efficiency.',
      icon: '🔗',
      details: [
        'Inventory management and optimization',
        'Logistics and warehousing solutions',
        'Demand planning and forecasting'
      ]
    },
    {
      title: 'Brand Stewardship',
      description: 'Active management and protection of brand integrity and performance.',
      icon: '🛡️',
      details: [
        'Brand positioning and compliance',
        'Performance monitoring and reporting',
        'Reputation management'
      ]
    },
    {
      title: 'Market Intelligence',
      description: 'Deep local insights to guide strategic decision-making.',
      icon: '🎯',
      details: [
        'Competitor analysis',
        'Consumer behavior insights',
        'Regulatory compliance guidance'
      ]
    },
    {
      title: 'Commercial Execution',
      description: 'Integrated commercial strategy implementation across markets.',
      icon: '⚡',
      details: [
        'Sales force effectiveness',
        'Trade marketing support',
        'Pricing strategy implementation'
      ]
    },
    {
      title: 'Sustainability Integration',
      description: 'Building sustainable and ethical business practices.',
      icon: '🌱',
      details: [
        'Ethical sourcing programs',
        'Environmental compliance',
        'Community engagement initiatives'
      ]
    }
  ];

  return (
    <>
    <Helmet>
  <title>Our Services – Route-to-Market & Supply Chain | Blackswift Inventories</title>
  <meta name="description" content="Explore Blackswift's services: route-to-market strategy, supply chain management, brand stewardship, market intelligence, and more across Southern Africa." />
</Helmet>
      <HeroSection 
        title="Integrated Route-to-Market Solutions"
        subtitle="We provide comprehensive distribution and brand management services across Southern Africa."
        buttonText="Contact Us"
        buttonLink="/contact"
        backgroundImage="/services-bg.jpg"   // <-- add your image path
        showIllustration={false}              // hide the animated illustration
      />

      <section className="section">
        <div className="container">
          <div className="services-intro">
            <h2>Our Services</h2>
            <p>
              As strategic growth partners to international manufacturers, we combine 
              market intelligence, brand stewardship, and disciplined execution to build 
              sustainable market leadership.
            </p>
          </div>

          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card fade-in">
                <div className="service-icon">{service.icon}</div>
                <h3>{service.title}</h3>
                <p>{service.description}</p>
                <ul className="service-list">
                  {service.details.map((detail, idx) => (
                    <li key={idx} className="service-list-item">{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Process Section */}
      <section className="section section-dark">
        <div className="container">
          <h2 className="text-center">Our Approach</h2>
          <div className="process">
            <div className="process-step">
              <div className="step-number">1</div>
              <h4>Market Assessment</h4>
              <p>Deep dive analysis and opportunity identification</p>
            </div>
            <div className="process-arrow">→</div>
            <div className="process-step">
              <div className="step-number">2</div>
              <h4>Strategy Design</h4>
              <p>Customized route-to-market planning</p>
            </div>
            <div className="process-arrow">→</div>
            <div className="process-step">
              <div className="step-number">3</div>
              <h4>Integrated Execution</h4>
              <p>End-to-end implementation across channels</p>
            </div>
            <div className="process-arrow">→</div>
            <div className="process-step">
              <div className="step-number">4</div>
              <h4>Performance Management</h4>
              <p>Ongoing optimization and growth monitoring</p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Services;